var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding-top: .5rem;\n  padding-left: 1.5rem;\n  color: ', ';\n  border: 1px solid ', ';\n  font-size: 1rem;\n  font-weight: 400;\n\n  &::placeholder {\n    color: ', ';\n  }\n}\n'], ['\n  width: 100%;\n  padding-top: .5rem;\n  padding-left: 1.5rem;\n  color: ', ';\n  border: 1px solid ', ';\n  font-size: 1rem;\n  font-weight: 400;\n\n  &::placeholder {\n    color: ', ';\n  }\n}\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Col } from 'reactstrap';
import Theme from '../../../Theme';

var _Theme$colors = Theme.colors,
    blueGrey = _Theme$colors.blueGrey,
    pearlGrey = _Theme$colors.pearlGrey;


var CommentField = styled.textarea.attrs(function (props) {
  return {
    cols: 30,
    rows: 4,
    placeholder: 'Your Comments',
    value: props.comment
  };
})(_templateObject, blueGrey, pearlGrey, blueGrey);

var CommentCol = function CommentCol(_ref) {
  var comment = _ref.comment,
      onCommentChange = _ref.onCommentChange;
  return React.createElement(
    Col,
    { md: '6' },
    React.createElement(
      'p',
      null,
      'What do you like most/least about this version of pga.org?'
    ),
    React.createElement(CommentField, { comment: comment, onChange: onCommentChange })
  );
};

CommentCol.propTypes = process.env.NODE_ENV !== "production" ? {
  comment: PropTypes.string,
  onCommentChange: PropTypes.func.isRequired
} : {};

export default CommentCol;